// extracted by mini-css-extract-plugin
module.exports = {"container":"ParallaxImage_container__IwLUV","imageParallax":"ParallaxImage_imageParallax__3BYVK"};